// @flow
import JQueryView from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';

declare var $: any;

export default class NewView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }
}
